import Breadcrumb from "../../../../components/breadcrumbs/Breadcrumb.vue";
import StandardPagination from "../../../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../../../components/actions/ActionButtons.vue";
import { EmpenhoSIAFService } from "../../../../services/EmpenhoSIAFService";

export default {
  name: "GerenciarEmpenhosSIAF",
  components: {
    Breadcrumb,
    StandardPagination,
    ActionButtons
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Página Inicial',
        disabled: false,
        href: '/',
      },
      {
        text: 'Processos de Compras',
        disabled: false,
        href: '/gerenciar-processos-compras',
      },
      {
        text: 'Gerenciar Empenho',
        disabled: true
      }
    ],
    headers: [
      { text: 'Número do Empenho', align: 'center', value: 'numero_empenho_completo', sortable: true },
      { text: 'Exercício', align: 'center', value: 'ano_registro_doc_empenho', sortable: true },
      { text: 'Elemento de Despesa', align: 'center', value: 'elemento_despesa', sortable: true },
      { text: 'Projeto Atividade', align: 'center', value: 'projeto_atividade', sortable: true },
      { text: 'Fonte de Recurso', align: 'center', value: 'fonte_recurso', sortable: true },
      { text: 'Processo de Compra SIAD', align: 'center', value: 'processo_compra_siad', sortable: true },
      { text: 'Despesa Empenhada', align: 'center', value: 'despesa_empenhada', sortable: true },
    ],
    filters: {
      exercicio: '',
      numeroEmpenho: '',
      unidadeOrcamentaria: '',
      projetoAtividade: '',
      elementoItem: '',
      fonte: '',
      valorEmpenhado: '',
      processoCompraSIAD: '',
    },
    anoOptions: [],
    items: [],
    itemSelected: [],
    page: 1,
    totalItems: 0,
    itemsPerPage: 10,
    itemsPerPageOptions: [10, 20, 50, 100],
    showFilters: true
  }),
  created() {
    this.generateAnoOptions();
    this.listarEmpenhosSIAFPaginado();
  },
  watch: {
    page: async function(newValue) {
      this.page = newValue;
      await this.listarEmpenhosSIAFPaginado();
    },
    itemSelected: {
      handler(newVal) {
        if (newVal.length > 1) {
          this.itemSelected = [newVal[newVal.length - 1]];
          this.$globalAlert('Apenas um registro pode ser selecionado por vez para visualização.', 'warning');
        }
      },
      deep: true
    },
    'filters.exercicio': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.numeroEmpenho': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.unidadeOrcamentaria': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.projetoAtividade': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.elementoItem': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.fonte': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.valorEmpenhado': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
    'filters.processoCompraSIAD': function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.listarEmpenhosSIAFPaginado();
      }
    },
  },
  computed: {
    computedHeaders() {
      return this.headers;
    },
    isAllSelected() {
      return this.items.length > 0 && this.itemSelected.length === this.items.length;
    },
    isIndeterminate() {
      return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
    }
  },
  methods: {
    generateAnoOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear; i >= currentYear - 10; i--) {
        years.push(i.toString());
      }
      this.anoOptions = years;
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    clearFilters() {
      this.filters = {
        exercicio: '',
        numeroEmpenho: '',
        unidadeOrcamentaria: '',
        projetoAtividade: '',
        elementoItem: '',
        fonte: '',
        valorEmpenhado: '',
        processoCompraSIAD: '',
      };
      this.page = 1;
      this.listarEmpenhosSIAFPaginado();
    },
    getNumeroEmpenhoCompleto(item) {
      if (item.numero_empenho_completo) {
        return item.numero_empenho_completo;
      }
      if (item.numero_empenho && item.unidade_executora_codigo) {
        return `${item.numero_empenho} / ${item.unidade_executora_codigo}`;
      }
      return item.numero_empenho || '-';
    },
    handleVisualizarDetalhe(item) {
      this.$router.push(`/empenhos-siaf/visualizar/${item.id}`);
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.itemSelected = [];
      } else {
        this.itemSelected = [...this.items];
      }
    },
    getRowClass(item) {
      return item.id % 2 === 0 ? 'even-row' : 'odd-row';
    },
    truncateText(text, maxLength) {
      if (!text) return '-';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0,00';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value);
    },
    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('pt-BR');
    },
    handlePageChange(newPage) {
      this.page = newPage;
      this.listarEmpenhosSIAFPaginado();
    },
    handleItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      this.listarEmpenhosSIAFPaginado();
    },
    async listarEmpenhosSIAFPaginado() {
      try {
        const filter = this.prepareFormFilter();
        const response = await EmpenhoSIAFService.index(filter);

        if (typeof response !== 'string') {
          this.items = response.data.data.map(item => this.transformItemForTemplate(item));
          this.totalItems = response.data.total;
          this.itemSelected = [];
          this.$forceUpdate();
        } else {
          console.error('Não foi possível obter os empenhos SIAF.');
        }
      } catch (error) {
        console.error('Ocorreu um erro ao listar os empenhos SIAF:', error);
      }
    },
    transformItemForTemplate(item) {
      return {
        ...item,
        numero_empenho_completo: item.numero_empenho_completo || this.getNumeroEmpenhoCompleto(item),
        ano_registro_doc_empenho: item.ano_registro_doc_empenho || '-',
        elemento_despesa: item.elemento_despesa || '-',
        projeto_atividade: item.projeto_atividade || '-',
        fonte_recurso: item.fonte_recurso || '-',
        processo_compra_siad: item.processo_compra_siad || '-',
        despesa_empenhada: item.despesa_empenhada || 0
      };
    },
    handleVisualizarEmpenho() {
      if (this.itemSelected.length === 0) {
        this.$globalAlert('Selecione um registro para visualizar.', 'error');
        return;
      }
      
      if (this.itemSelected.length > 1) {
        this.$globalAlert('Selecione apenas um registro para visualizar.', 'error');
        this.itemSelected = [this.itemSelected[0]];
        return;
      }
      
      this.$router.push(`/empenhos-siaf/visualizar/${this.itemSelected[0].id}`);
    },
    handleExportar() {
      this.$globalAlert('Não implementado!');
    },
    async destroyEmpenhos() {
      try {
        const ids = this.itemSelected.map(empenho => empenho.id);
        const formData = new FormData();

        ids.forEach(id => formData.append("empenhos[]", id));

        const response = await EmpenhoSIAFService.destroy(formData);

        if (!response) {
          console.error('Não foi possível excluir os empenhos SIAF.');
        }

        this.listarEmpenhosSIAFPaginado();
      } catch (error) {
        console.error('Ocorreu um erro ao excluir os empenhos SIAF:', error);
      }
    },
    prepareFormFilter() {
      const filter = new FormData();
      filter.append("page", this.page);
      filter.append("items_per_page", this.itemsPerPage);

      if (this.filters.exercicio) {
        filter.append("exercicio", this.filters.exercicio);
      }
      if (this.filters.numeroEmpenho) {
        filter.append("numero_empenho", this.filters.numeroEmpenho);
      }
      if (this.filters.unidadeOrcamentaria) {
        filter.append("unidade_orcamentaria", this.filters.unidadeOrcamentaria);
      }
      if (this.filters.projetoAtividade) {
        filter.append("projeto_atividade", this.filters.projetoAtividade);
      }
      if (this.filters.elementoItem) {
        filter.append("elemento_item", this.filters.elementoItem);
      }
      if (this.filters.fonte) {
        filter.append("fonte", this.filters.fonte);
      }
      if (this.filters.valorEmpenhado) {
        filter.append("valor_empenhado", this.filters.valorEmpenhado);
      }
      if (this.filters.processoCompraSIAD) {
        filter.append("processo_compra_siad", this.filters.processoCompraSIAD);
      }

      return filter;
    }
  }
};

